module.exports = __webpack_public_path__ + "images/classic-d9580292a2d2ef92ab56fec257f682db.jpg";